"use client";

// import { Input } from "@headlessui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { getSearchResultUrl } from "~/src/lib/ui/transition";

type SearchFormProps = {
  isDarkMode?: boolean;
};

//------------
// モードデザイン
//------------
const LIGHT_PARENT = "bg-WHITE_1 border border-GRAY_3";
const LIGHT_ICON = "text-GRAY_2";
const LIGHT_FORM = "text-GRAY_1 placeholder:text-PLACEHOLDER disabled:bg-GRAY_3";

const DARK_PARENT = "border-0.5 border-WHITE_1 bg-WHITE_1/20";
const DARK_ICON = "text-WHITE_1";
const DARK_FORM = "bg-WHITE_1/0 text-WHITE_1";

/**
 * 検索フォーム
 */
export default function SearchForm({ isDarkMode }: SearchFormProps) {
  const router = useRouter();
  const [query, setQuery] = useState("");
  const [classNameParent, setClassNameParent] = useState("");
  const [classNameIcon, setClassNameIcon] = useState("");
  const [classNameForm, setclassNameForm] = useState("");

  /**
   * モード切替検出
   */
  useEffect(() => {
    //------------
    // モードを切り替え
    //------------
    if (isDarkMode) {
      setClassNameParent(DARK_PARENT);
      setClassNameIcon(DARK_ICON);
      setclassNameForm(DARK_FORM);
    } else {
      setClassNameParent(LIGHT_PARENT);
      setClassNameIcon(LIGHT_ICON);
      setclassNameForm(LIGHT_FORM);
    }
  }, [isDarkMode]);

  /**
   * 検索フォームEnter押下時処理
   */
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // フォーム上でEnterが押されたとき、検索処理に入る
    if (e.key === "Enter" && query.trim() !== "") {
      const url = getSearchResultUrl(query);
      router.push(url);
    }
  };

  return (
    <div
      className={`flex items-center rounded-md px-3 transition-colors duration-200 ease-in-out ${classNameParent}`}
    >
      <MagnifyingGlassIcon
        aria-hidden="true"
        className={`size-5 bg-WHITE_1/0 transition-colors duration-200 ease-in-out ${classNameIcon}`}
      />
      <input
        type="text"
        placeholder="作品名などで検索"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        className={`block min-w-96 grow py-1.5 pl-2 pr-3 text-base transition-colors duration-200 ease-in-out focus:outline focus:outline-0 sm:text-sm/6 ${classNameForm}`}
      />
    </div>
  );
}
